﻿import * as React from "react";
import { RioAuditContextModel } from "../apiModels/audit/RioAuditContextModel";

export const RioAuditContext = React.createContext<RioAuditContextModel>(null);